import { useState, useEffect } from "react";

import "../css/CashPopup.css";

import ButtonIconH from "../../components/ButtonIconH";
import Dropdown from "../../components/Dropdown";
import InputData from "../../components/InputData";
import InputTextArea from "../../components/InputTextArea";

import { post } from "../../js/post";
import { post as rpost } from "../js/api";
import { userData, selectedOptic } from "../../js/utils";

export default ({
  type,
  show,
  onClose,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");

  const loadPaymentMethods = async () => {
    const response = await post("ListarFormasPago.php", {
      token: userData.token,
    });
    // El vale de caja no es una forma de pago válida para meter/sacar dinero.
    const paymentMethodsN = response
      .filter(
        (item) =>
          String(item.descripcion ?? "")
            .trim()
            .toUpperCase() !== "VALE DE CAJA",
      )
      .map((item) => {
        return {
          id: item.id,
          text: item.descripcion,
        };
      });
    setPaymentMethods(paymentMethodsN);
    setPaymentMethod(paymentMethodsN[0]);
  };

  useEffect(() => {
    if (show) {
      setPrice("");
      setDescription("");
      loadPaymentMethods();
      setTimeout(() => {
        document.getElementById("cash-movement-importe")?.focus();
      }, 100);
    }
  }, [show]);

  const onChangePrice = (e) => {
    setPrice(e);
  };

  const onChangeDescription = (e) => {
    setDescription(e);
  };

  const onChangePaymentMethod = (e) => {
    setPaymentMethod(e);
  };

  const insertExtract = async () => {
    if (price.trim() === "" || description.trim() === "") {
      createPopupQuestion(
        "Debe rellenar todos los campos del formulario.",
        removePopupQuestion,
        null,
        "Cerrar",
      );

      return;
    }

    if (parseInt(price) <= 0) {
      createPopupQuestion(
        "El importe debe ser mayor que cero.",
        removePopupQuestion,
        null,
        "Cerrar",
      );

      return;
    }

    await rpost("ventas/MeterSacarCaja.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      abono: type === "insertion" ? price : -price,
      empleado: userData.id,
      formaPago: paymentMethod.text,
      descripcion: description,
    });

    onClose();
  };

  return (
    show && (
      <div className="popup-container popup-normal popup-cash-movement">
        <div className="popup-message">
          <div className="popup-header">
            <div className="popup-title">
              {type === "insertion"
                ? "Inserción manual en caja"
                : "Extracción manual de caja"}
            </div>
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt=""
              className="popup-close"
              onClick={onClose}
            />
          </div>
          <div className="popup-body">
            <div className="popup-row">
              <div className="label">Importe (€)</div>
              <InputData
                id="cash-movement-importe"
                tabIndex={20001}
                type="type-float"
                size={1}
                input={price}
                onChange={onChangePrice}
              />
            </div>
            <div className="popup-row popup-row-top">
              <div className="label">Motivo</div>
              <InputTextArea
                tabIndex={20002}
                maxLength={400}
                type="type-full"
                size={3}
                input={description}
                onChange={onChangeDescription}
              />
            </div>
            <div className="popup-row">
              <div className="label">Forma de pago</div>
              <Dropdown
                tabIndex={20003}
                id="cash-movement-payment-method"
                disabled={false}
                optionList={paymentMethods}
                size={3}
                op={paymentMethod ? paymentMethod.id : null}
                onChange={onChangePaymentMethod}
              />
            </div>
          </div>
          <div className="popup-cash-footer">
            <ButtonIconH
              text={type === "insertion" ? "Insertar" : "Extraer"}
              onClick={insertExtract}
            />
          </div>
        </div>
      </div>
    )
  );
};
